import React, { Dispatch, SetStateAction } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

interface IUnMute {
  unMuteAlert: true;
  setUnMuteAlert: Dispatch<SetStateAction<boolean>>;
}

function UnMuteAlertDialog({ unMuteAlert, setUnMuteAlert }: IUnMute) {
  return (
    <Dialog open={unMuteAlert} fullWidth={true} maxWidth="xs">
      <DialogTitle>UnMute Main Video</DialogTitle>
      <DialogContent>
        <DialogContentText>Please Unmute main Video to start Recording</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setUnMuteAlert(!unMuteAlert)} variant="contained" color="secondary" autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UnMuteAlertDialog;
